// ESM entry of the vrm_core glue: the logic is vrm_core.cjs (the game server
// require()s that file; one glue, two module systems)
export { instantiateSync, instantiate, fromExports } from './vrm_core.cjs';
